// extracted by mini-css-extract-plugin
module.exports =  {"root":"Ben5sTDw6NnYjZ_zRolK","tab":"wwaqMVHHkAzUGvEYPsIO"};